import BeeyApp, { useSession } from './components/BeeyApp/index.js';
import { useI18n } from './components/I18n/index.js';
import LangSelect from './components/LangSelect/index.js';
import transcriptionLangs from './resources/transcription-langs.json';
import Localization from './components/I18n/localization.js';
import { initLongPolling } from './common/polling.js';
export { useSession, useI18n, Localization, LangSelect, transcriptionLangs, initLongPolling, };
export default BeeyApp;
